import { render } from "./bauBegleitung.vue?vue&type=template&id=c9f1f13c"
import script from "./bauBegleitung.vue?vue&type=script&lang=js"
export * from "./bauBegleitung.vue?vue&type=script&lang=js"

import "./bauBegleitung.vue?vue&type=style&index=0&id=c9f1f13c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__